export default class InterfaceRuleSpecification {
  constructor () {
    if (new.target === 'InterfaceRuleSpecification') {
      throw new TypeError('Cannot construct Abstract instances directly')
    }
  }

  /**
   * @param entity
   *
   * @return boolean
   */
  isSatisfiedBy (entity) {}
}
